import { httpClient } from '../httpClient';
import {
  IVideoClip,
  CreateVideoClipRequest,
  UpdateVideoClipRequest,
  PaginatedResponse,
  VideoClipQuery,
  PaginationQuery
} from '@packages/global';

/**
 * 用户视频片段 API 模块
 * 处理用户视频片段管理操作
 */
export class VideoClipApi {

  /**
   * 获取用户视频片段分页列表（POST，强类型）
   */
  async videoClipPageList(queryData: PaginationQuery<VideoClipQuery>): Promise<PaginatedResponse<IVideoClip>> {
    return httpClient.post<PaginatedResponse<IVideoClip>>('/user/videoclips/page', queryData);
  }

  /**
   * 获取单个视频片段
   */
  async getVideoClip(id: string): Promise<IVideoClip> {
    return httpClient.get<IVideoClip>(`/user/videoclips/${id}`);
  }

  /**
   * 创建视频片段
   */
  async createVideoClip(data: CreateVideoClipRequest): Promise<IVideoClip> {
    return httpClient.post<IVideoClip>('/user/videoclips', data);
  }

  /**
   * 更新视频片段
   */
  async updateVideoClip(id: string, data: UpdateVideoClipRequest): Promise<IVideoClip> {
    return httpClient.put<IVideoClip>(`/user/videoclips/${id}`, data);
  }

  /**
   * 删除视频片段
   */
  async deleteVideoClip(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/videoclips/${id}`);
  }
}

// 导出单例实例
export const videoClipApi = new VideoClipApi();